// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"680":"1e41b8f6","760":"f22c2215"}[chunkId] + ".css";
};